"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

require("phoenix_html");

var _trumbowyg = require("trumbowyg");

var _trumbowyg2 = _interopRequireDefault(_trumbowyg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import local files
//
// Local files can be imported directly using relative
// paths "./socket" or full ones "web/static/js/socket".

// import socket from "./socket"

var App = exports.App = {
  run: function run() {
    console.log("Main App.");
  }
}; // Brunch automatically concatenates all files in your
// watched paths. Those paths can be configured at
// config.paths.watched in "brunch-config.js".
//
// However, those files will only be executed if
// explicitly imported. The only exception are files
// in vendor, which are never wrapped in imports and
// therefore are always executed.

// Import dependencies
//
// If you no longer want to use a dependency, remember
// to also remove its path from "config.paths.watched".


$.trumbowyg.svgPath = '/icons.svg';


$(document).ready(function () {
  $('.wysiwygarea').trumbowyg();

  $("input[name$='add_paper[type]']").click(hidePosterAward);
  $("input[name$='add_paper[type]']:checked").each(hidePosterAward);
  function hidePosterAward() {
    if ($(this).val() === "poster") {
      $(".poster-award-div").show();
    } else {
      $(".poster-award-div").hide();
    }
  }
});

// Show info about the selected existing author
$("#existing_author_select").change(function () {
  var user_id = $("#existing_author_select option:selected").attr("value");
  $.get("/api/user_info?user_id=" + user_id, function (data) {
    $("#existing_author_name").html(data.name);
    $("#existing_author_affiliation").html(data.affiliation);
    $("#existing_author_city").html(data.city);
    $("#existing_author_country").html(data.country);
  });
});

// Pre-fill participant billing address based on the selected existing user
$("#existing_user_select").change(function () {
  var user_id = $("#existing_user_select option:selected").attr("value");
  $.get("/api/user_info_full?user_id=" + user_id, function (data) {
    $("#participant_address_city").val(data.city);
    $("#participant_address_street").val(data.street);
    $("#participant_address_postal_code").val(data.postal_code);
    $("#participant_address_affiliation").val(data.affiliation);
    $("#participant_address_country").val(data.country);
  });
});

$(document).ready(function () {
  privateHideEverything();
  hideDic();
  hideIcdph();
  $("#fees_paid_by_private_radio,#fees_paid_by_company_radio").change(privateHideEverything);
  $("#no_dic_checkbox").change(hideDic);
  $("#no_icdph_checkbox").change(hideIcdph);
  function privateHideEverything() {
    if ($("#fees_paid_by_private_radio").is(':checked')) {
      $("#ico_div").hide();
      $("#no_dic_div").hide();
      $("#dic_div").hide();
      $("#no_icdph_div").hide();
      $("#icdph_div").hide();
    } else {
      $("#ico_div").show();
      $("#no_dic_div").show();
      $("#dic_div").show();
      $("#no_icdph_div").show();
      $("#icdph_div").show();
    }
    hideDic();
    hideIcdph();
  }
  function hideDic() {
    if ($("#no_dic_checkbox").is(':checked')) {
      $("#dic_div").hide();
    } else {
      if (!$("#fees_paid_by_private_radio").is(':checked')) {
        $("#dic_div").show();
      }
    }
  }
  function hideIcdph() {
    if ($("#no_icdph_checkbox").is(':checked')) {
      $("#icdph_div").hide();
    } else {
      if (!$("#fees_paid_by_private_radio").is(':checked')) {
        $("#icdph_div").show();
      }
    }
  }
});

$(document).ready(function () {
  feeChange();
  $('[name="participant\[registration_fee\]"]').change(feeChange);
  function feeChange() {
    var fee = $('input[name="participant\[registration_fee\]"]:checked').val();
    var hiddenFee = $('#registration_fee_hidden').text();
    if (typeof fee !== 'undefined' && fee.includes("short")) {
      $("#visit_date_div").show();
    } else {
      $("#visit_date_div").hide();
    }
    if (typeof fee !== 'undefined' && fee.includes("students") || hiddenFee.includes("students")) {
      $("#student_confirmation_div").show();
    } else {
      $("#student_confirmation_div").hide();
    }
  }
});

// Suggest existing authors when someone tries to create a new one
$("#new_author_surname").focusout(suggest_authors);
$("#new_author_first_name").focusout(suggest_authors);

function suggest_authors() {
  var first_name = $("#new_author_first_name").val();
  var surname = $("#new_author_surname").val();
  if (first_name.length >= 2 && surname.length >= 2) {
    $.get("/api/find_authors?first_name=" + first_name + "&surname=" + surname, function (data) {
      if (data.length > 0) {
        var html_array = data.map(function (value, index, array) {
          var result = '<div class="row" style="margin-bottom: 5px;"><div class="col-md-8">' + value.name + " (" + value.affiliation + "; " + value.city + "; " + value.country + ")</div>";
          result += '<div class="col-md-2"><button class="btn btn-sm btn-success" name="add_suggested_author" type="submit" value="' + value.id + '">Add this author</button></div></div>';
          return result;
        });
        $("#suggested_authors").html("Did you perhaps mean some of these existing authors? <br/><br/>" + html_array.join(""));
      } else {
        $("#suggested_authors").html("");
      }
    });
  }
}
